import updateEmailRoute from "pages/api/user/update-email.route";
import { post } from "./lib";

export const updateUserEmail = async (email: string) => {
  try {
    const response = await post<typeof updateEmailRoute>(
      "/api/user/update-email",
      { email }
    );
    if (!response) {
      throw new Error("No response from server");
    }
    return response;
  } catch (error) {
    console.error("Error updating email:", error);
    throw new Error("Failed to update email");
  }
};
